export const EquipmentDestination = {
  KEEP_RENTED: "MANTER ALUGADO",
  KEEP_RESERVED: "MANTER RESERVADO",
  RETURN_TO_CLIENT: "DEVOLVER EQUIPAMENTO PARA CLIENTE",
  WILL_BE_REPLACED: "SERÁ SUBSTITUÍDO",
  REQUEST_DISPOSAL: "SOLICITAR BAIXA",
  AVAILABLE_FOR_RENT: "LIBERAR PRA LOCAÇÃO",
  INTERNAL_USE: "USO INTERNO",
  WARRANTY: "GARANTIA",
};
